const language_switcher = document.querySelectorAll('.language-switcher');
if(language_switcher) {
  language_switcher.forEach(function(item) {
    item.querySelector('.current-lang').addEventListener('click', function() {
    if(item.classList.contains('show')) {
      item.classList.remove('show');
    }
    else {
      item.classList.add('show');
    }
  });
});

  window.addEventListener('click', function(e) {
    if (!e.target.closest('.language-switcher') && document.querySelector('.language-switcher.show')) {
      language_switcher.forEach(function(item) {
        item.classList.remove('show');
      });
    }
  });
}